export enum EcoIntegrationTypeEnum {
  WOO = 'WOO',
  SHOPIFY = 'SHOPIFY',
}
